import React,{useState} from "react";
import { AiOutlineRead } from "react-icons/ai";
import { GrClose } from "react-icons/gr";
import { MdDownload } from "react-icons/md";
import {Helmet} from "react-helmet"
import {journal} from "../../../data/journals"
import PdfViewer from './PDFViewer';

const Journals = props => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const openModal = (url) => {
    setPdfUrl(url);
    setIsModalOpen(true);
  }
 
 const filteredJournals = journal.filter((j) =>
    `${j.title} ${j.subtitile}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
        <>
        <Helmet>
        <title>Benadir University Journal | BU Research</title>
        <meta name="description" content="Explore academic journals and research publications from Benadir University. Stay updated with the latest studies and scholarly articles." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://bu.edu.so/research/journals" />
      </Helmet>
          <div className="px-5">
            <div className="my-3">
              <h1 className="text-3xl sm:text-xl xs:text-xl">Explore Our Latest Scholarly Journals and Research Contributions</h1>
            </div>
            <div className="bg-[#EDF4F4] ">
              <div className="col-span-10 w-full">
                <input
                  type="text"
                  placeholder="Search Here, title or sub title..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full py-3 px-3 outline-none rounded-md"
                />
              </div>
            </div>
                  <div className="grid xl:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 xs:grid-cols-1 gap-4 place-items-center w-full my-2 py-3">
          {filteredJournals.length > 0 ? (
            filteredJournals.map((j) => (
              <div
                key={j.id}
                className="border-2 border-cyan-500 w-[250px] h-[300px] flex flex-col justify-center bg-gray-200 bg-cover" 
                style={{ backgroundImage: `url(${j.bg})` }}
              >
                {
                  j.bg ? (
                <div className="relative flex flex-col justify-end items-center h-[80%] px-5 space-y-3 w-full">
                      <div className="w-full text-3xl flex justify-center h-[20%] space-x-2 px-3 py-5">
                  <button type="button" className="cursor-pointer" onClick={() => openModal(j.fileUrl)}>
                    <AiOutlineRead />
                  </button>
                  {j.doi && (
                    <a href={j.doi} target="_blank" rel="noopener noreferrer">
                      <MdDownload />
                    </a>
                  )}
                </div>
                </div>
                    
                  ) : (
                      <>
                <div className="relative flex flex-col justify-center items-center h-[80%] px-5 space-y-3 w-full">
                  <p className="text-xl font-semibold text-center">{j.title}</p>
                  <p className="text-base text-center">{j.subtitile}</p>
                </div>
                <div className="w-full text-3xl flex justify-center h-[20%] space-x-2 px-3 py-5">
                  <button type="button" className="cursor-pointer" onClick={() => openModal(j.fileUrl)}>
                    <AiOutlineRead />
                  </button>
                  {j.doi && (
                    <a href={j.doi} target="_blank" rel="noopener noreferrer">
                      <MdDownload />
                    </a>
                  )}
                </div>
                  </>
                  )
                }

              </div>
            ))
          ) : (
            <p className="col-span-full text-center text-lg text-gray-500">No results found.</p>
          )}
        </div>
      </div>
           <div className={`fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-end items-start z-30 ease-in duration-300 ${isModalOpen ? "" : "hidden"}`} >
            <div className="flex flex-col w-full">
            <div className="flex w-full justify-end py-2 px-5"><GrClose className="text-3xl text-white bg-white" onClick={() => setIsModalOpen(!isModalOpen)}/></div>
           <PdfViewer fileUrl={pdfUrl} />
          </div>
          </div>

          </>

  );
};

export default Journals;